export default __webpack_public_path__ + "static/media/stack-chips.f64ab5ed.webp";